import grey from 'material-ui/colors/grey';
import red from 'material-ui/colors/red';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    rootRevisionsTable: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    rootGrid: {
        flexGrow: 1,
    },
    table: {
        minWidth: 700,
        overflowX: 'auto',
    },
    tableCell: {
        padding: '4px 15px 4px 20px',
        cursor: 'default'
    },
    tableCellCenter: {
        textAlign: 'center',
        padding: '4px 15px 4px 20px',
    },
    tableIconBtn: {
        textAlign: 'center',
        padding: '5px 15px 5px 0',
    },
    headerLabels: {
        fontWeight: '700',
        fontSize: '0.9rem',
    },
    buttons: {
        padding: '15px 0 0 15px'
    },
    inputFormField: {
        marginTop: '32px',
        marginBottom: '8px',
        color: '#000',
    },
    inputFormFieldDisabled: {
        marginTop: '32px',
        marginBottom: '8px',
        color: 'rgb(114, 114, 114)',
    },
    blockViewContent: {
        padding: '15px'
    },
    blockContentParagraph: {
        color: '#666',
        margin: '0',
        '& p': {
            margin: 0
        }
    },
    blockViewLead: {
        fontSize: '18px'
    },
    disabledRow: {
        background: grey[100],
    },
    disabledRadio: {
        color: 'rgba(0, 88, 61, 0.61)'
    },
    textEditor: {
        marginTop: '30px'
    },
    messageNoEntries: {
        fontSize: '18px',
        height: '200px',
        textAlign: 'center',
        paddingTop: '85px',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    containerLineOne: {
        display: 'flex',
        flexDirection: 'row',
    },
    containerLineTwo: {
        display: 'block',
        flexDirection: 'row',
    },
    textField: {
        marginLeft: 0,
        marginRight: theme.spacing.unit,
        width: 248,
    },
    menu: {
        width: 200,
    },
    selectMenuItem: {
        fontSize: '14px',
        paddingTop: 0,
        paddingBottom: 5,
    },
    selectMenuItemFilters: {
        fontSize: '14px',
        padding: '0 15px'
    },
    filterButton: {
        marginLeft: 0,
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
    },
    blocksEditorLabel: {
        margin: '30px 0',
    },
    blocksEditorContent: {
        marginTop: 10,
    },
    dialogActionsBtn: {
        margin: '8px 19px'
    },
    blockImageField: {
        padding: 10,
    },
    [theme.breakpoints.up('xs')]: {
        blockViewHeading: {
            height: '80px',
        },
        blockViewLead: {
            margin: '0'
        },
        textField: {
            width: '100%',
            margin: 0
        },
    },
    [theme.breakpoints.up('sm')]: {
        root: {
            width: '90%',
        },
        blockViewHeading: {
            height: '60px'
        },
        blockViewLead: {
            margin: '18px 0'
        },
        textField: {
            width: '100%',
            margin: 0
        },
    },
    [theme.breakpoints.up('md')]: {
        root: {
            width: '95%',
        },
    },
    [theme.breakpoints.up('lg')]: {
        root: {
            width: '97%',
        },
    },
    [theme.breakpoints.up('xl')]: {
        root: {
            width: '100%',
        },
    },
    blocksActionButtons: {
        marginTop: '15px',
    },
    galleryError: {
        background: red[500],
        color: '#fff',
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/blocks/style/styles.js